import { render, staticRenderFns } from "./BaOperatorAllHoldings.vue?vue&type=template&id=c58cf762&scoped=true&"
import script from "./BaOperatorAllHoldings.vue?vue&type=script&lang=js&"
export * from "./BaOperatorAllHoldings.vue?vue&type=script&lang=js&"
import style0 from "./BaOperatorAllHoldings.vue?vue&type=style&index=0&id=c58cf762&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58cf762",
  null
  
)

export default component.exports